import axios from 'axios'
import { API, SESSION } from '@/constants/constants'

export function apiHelper(apiUrl = null, appendAuthHeader = true) {
  let baseURL = apiUrl === null ? API.BASE_URL : apiUrl
  let token = localStorage.getItem(SESSION.TOKEN)
  let authHeader = token && appendAuthHeader ? { Authorization: 'Bearer ' + token } : {}

  const responseHandler = response => {
    localStorage.setItem(SESSION.LAST_ACTIVITY_TIME, JSON.stringify(new Date().getTime()))
    return response.data
  }

  const errorHandler = error => {
    // No response at all (network down, CORS, timeout). The previous version assigned to
    // error.response.status inside this branch, which threw a second TypeError and hid the
    // original failure.
    if (!error.response) {
      throw {
        success: false,
        code: '0.96',
        error: error.message || 'Network Error'
      }
    }

    const data = error.response.data || {}

    // An expired or blacklisted token invalidates the whole session. Clear it so the next
    // navigation sends the member through login instead of leaving every request failing.
    // Deliberately no redirect here: pushing a route from the interceptor loops on pages that
    // are reachable while logged out.
    if (error.response.status === 401 && (data.code === '0.5' || data.code === '0.92')) {
      localStorage.removeItem(SESSION.USERNAME)
      localStorage.removeItem(SESSION.TOKEN)
      localStorage.removeItem(SESSION.TOKEN_EXPIRY)
    }

    throw data
  }

  let apiInstance = axios.create({
    baseURL,
    headers: authHeader
  })

  apiInstance.interceptors.response.use(
    response => responseHandler(response),
    error => errorHandler(error)
  )

  return apiInstance
}
